import { fromJS } from 'immutable'

export default fromJS({
  questions: {
    noAlt: 'חסר טקסט חלופי לתמונה זו',
    noAnswers: 'אין אפשרות לתשובה, יש ללחוץ ״הבא״ כדי להמשיך.',
    placeholder: 'יש לציין',
    pleaseSelect: 'יש לבחור',
    rotateLandscape: 'אנא כבה את נעילת הכיוון בטלפון שלך וסובב אותו למצב רוחבי כדי להמשיך.',
    rotatePortrait: 'אנא סובב את הטלפון שלך מרוחב לפורטרייט כדי להמשיך.',
    ir: {
      selectWebCam: 'יש לבחור מצלמת רשת (אם זמינה) או ללחוץ ׳עיון׳ כדי להעלות קובץ מהמכשיר שלכם',
      // uploadOnly: "Кликнете върху 'עיון', за да качите от Вашето устройство",
      noWebCam: 'לא נמצאה מצלמת רשת',
      accessCamUpload: 'גישה למצלמה/העלאת קובץ',
      browse: 'עיון',
      uploadPhoto: 'העלאת תמונה',
      camera: 'מצלמת רשת',
      instead: 'במקום',
      capture: 'צילום',
      somethingWrong: 'סליחה, משהו השתבש. יש לנסות שוב מאוחר יותר',
      couldntRead: 'מצטערים, לא הצלחנו לקרוא את הקוד!',
      couldntProcess: 'מצטערים, לא הצלחנו לעבד את התמונה שלכם!',
      inValidCode: 'יש לשלוח את הקוד התקין',
      moveOn: 'יש לנסות שוב או לשלוח את התמונה שלכם ולהמשיך הלאה',
      tryAgain: 'יש לנסות שוב',
      dataReceived: 'המידע התקבל!',
      enterManually: 'יש לנסות שוב או להכניס את המידע למטה באופן ידני',
      positionQR: 'יש למקם את קוד ה-QR מול המצלמה שלכם ולהכניס אותו למסגרת האדומה, או להעלות מהמחשב שלכם.',
      positionQRMobile: 'יש למקם את קוד ה-QR מול המצלמה שלכם או להעלות מהמחשב שלכם.',
      analyzing: 'מתבצע ניתוח לתמונה, אנא המתינו',
      submit: 'שליחה',
      startOver: 'התחילו מחדש',
      allDone: 'סיימנו!',
      cantAnalyze:
        'שימו לב - לא הצלחנו לעבד את התמונה הזאת. יש לנסות לשלוח מחדש או לבחור תמונה בפורמט יותר גנרי (JPG, PNG, GIF, BMP)',
      wrongFormat:
        'אנחנו מצטערים - אנחנו לא תומכים בסוג הקובץ הזה. יש להעלות תמונה בפורמט נתמך (JPG, PNG, GIF, BMP, TIF, PDF, SVG)'
    },
    vr: {
      noWebCam: 'לא נמצאה מצלמת רשת',
      uploadVideo: 'העלאת סרטון',
      skip: 'לדלג?',
      accessCamUpload: 'גישה למצלמה/העלאת קובץ',
      browse: 'עיון',
      instead: 'במקום',
      or: 'או',
      stopRecording: 'עצרו את הקלטה',
      willBeStopped: 'ההקלטה תיעצר בעוד 5 דקות',
      stopOnDone: 'עצרו את ההקלטה כשתסיימו!',
      record: 'הקלטה',
      somethingWrong: 'סליחה, משהו השתבש. יש לנסות שוב מאוחר יותר',
      dataReceived: 'המידע התקבל!',
      microphone: 'המיקרופון',
      camera: 'מצלמת רשת',
      selectMicrophone: 'יש לבחור את המיקרופון שלכם',
      selectCam: 'יש לבחור את מצלמת הרשת שלכם',
      submit: 'שליחה',
      upload: 'העלו',
      playback: 'הפעלה',
      stopPlayback: 'עצרו את ההפעלה',
      startOver: 'התחילו מחדש',
      allDone: 'סיימנו!',
      alternativeRecordSpan: 'יש להעלות את הסרטון מהמחשב שלכם. לחלופין, תוכלו לצלם את הסרטון  &nbsp;',
      alrenativeRecordHref: 'עם מצלמת רשת',
      cantAnalyze:
        'שימו לב - לא הצלחנו לעבד את הסרטון הזה. יש לנסות לשלוח מחדש או לבחור סרטון בפורמט יותר גנרי (MP4, M4V, WEBPM)',
      wrongFormat:
        'אנחנו מצטערים - אנחנו לא תומכים בסוג הקובץ הזה. יש להעלות סרטון בפורמט נתמך (MP4, AVI, M4V, WEBPM, MOV, MKV, MPG, WMV)'
    },
    cjc: {
      choose: 'בחירה',
      pleaseChoose: 'יש לבחור',
      this: 'זה',
      one: ' אחד',
      myChoice: 'הבחירה שלי'
    },
    hm: {
      addComment: 'יש להוסיף תגובה מתחת',
      commentMandatoryPlaceHolder: 'יש להוסיף תגובת חובה... ',
      commentOptionalPlaceHolder: 'יש להוסיף תגובה אופציונלית...',
      dragPin: 'יש לגרור כדי למקם מחדש לחיצה ארוכה הקשה עבוד נעיצה מדויקת.',
      removePin: 'יש לגרור אל מחוץ לתמונה כדי למחוק. ',
      editComment: 'לחצו הקישו על סיכה כדי לערוך את התגובה.',
      addPin: 'יש לגרור את הסיכה מהלוח שלמטה ולהניח אותה בנקודה שתבחרו על התמונה.',
      addPins: 'יש לגרור את הסיכות מהלוח שלמטה ולהניח אותן בנקודה שתבחרו על התמונה.',
      leavePins: (minPoints, maxPoints) => `סיכות מכל סוג. ${maxPoints} ולא יותר מ- ${minPoints} יש להשאיר לפחות`,
      leavePinsAny: (minPoints, maxPoints) => `סיכות מכל סוג. ${maxPoints} ולא יותר מ- ${minPoints} יש להשאיר לפחות`,
      leavePinsPerPage: (minPoints, maxPoints) =>
        `סיכות מכל סוג. ${maxPoints} ולא יותר מ ${minPoints} יש להשאיר לפחות `,
      leavePinsWithOff: maxPoints => `סיכות מכל סוג או ללחוץ ׳הבא׳ כדי לדלג. ${maxPoints} יש להשאיר לא יותר מ `,
      leavePinsWithOffAny: maxPoints => `סיכות מכל סוג או ללחוץ ׳הבא׳ כדי לדלג. ${maxPoints} יש להשאיר לא יותר מ- `,
      leavePinsPerPageWithOff: maxPoints => `סיכות מכל סוג או ללחוץ ׳הבא׳ כדי לדלג. ${maxPoints} יש להשאיר לא יותר מ `,
      leavePinWithOff: `יש להשאיר לא יותר מסיכה אחת מכל סוג או ללחוץ ׳הבא׳ כדי לדלג. `,
      leavePinWithOffAny: `יש להשאיר לא יותר מסיכה אחת מכל סוג או ללחוץ ׳הבא׳ כדי לדלג.`,
      leavePinPerPageWithOff: 'יש להשאיר סיכה אחת. ',
      leaveExactlyPin: `יש להשאיר סיכה אחת מכל סוג.`,
      leaveExactlyPinAny: `יש להשאיר לא יותר מסיכה אחת מכל סוג או ללחוץ ׳הבא׳ כדי לדלג. `,
      leaveExactlyPinPerPage: 'יש להשאיר סיכה אחת מכל סוג.',
      leaveExactlyPins: maxPoints => `סיכות מכל סוג. ${maxPoints} יש להשאיר `,
      leaveExactlyPinsAny: maxPoints => `סיכות מכל סוג. ${maxPoints} ייש להשאיר `,
      leaveExactlyPinsPerPage: maxPoints => `סיכות. ${maxPoints} יש להשאיר `,
      leaveComment: 'הקלידו מתחת לתמונה כדי להשאיר תגובה.',
      noAnswers: 'אין אפשרות לתשובה, יש ללחוץ ״הבא״ כדי להמשיך.',
      outOfPins: 'נגמרו לך הסיכות',
      pinsBehavior: 'כשתתקדמו לאורך התמונה תראו אזורים שמסומנים על ידי סיכה נעוצה אחת.',
      clusters: 'תוכלו למקם סיכות רק באזורים המסומנים האלה.',
      contentAware: 'אתם יכולים למקם סיכות בתוך ומחוץ לאזורים המסומנים.'
    },
    mp: {
      expand_note: 'יש להעביר את הסמן מעל או ללחוץ על תמונה/תמונות כדי להגדיל',
      rb_note: rows => `${rows ? 'למטה' : ''} יש לבחור רק תגובה אחת לכל פריט :`,
      cb_note: (min, max, rows) => {
        if (min === max) {
          return ` יש לבחור ${min !== 1 ? 'כלשהן' : 'בלבד'} ${min} ${min !== 1 ? 'תגובות' : 'תגובה'} עבור כל פריט מטה:`
        } else if (min > 0 && max < 5000) {
          return ` יש לבחור לפחות ${min} ${min !== 1 ? 'תגובות' : 'תגובה'} אך לא יותר מ- ${max} ${
            rows ? 'למטה' : ''
          } עבור כל פריט : `
        } else if (5000 === max && min > 0) {
          return ` יש לבחור לפחות ${min} ${min !== 1 ? 'תגובות' : 'תגובה'} ${rows ? 'למטה' : ''} עבור כל פריט :`
        } else if (0 === min && max < 5000) {
          return ` ש לבחור לא יותר מ- ${max} ${max !== 1 ? 'תגובות' : 'תגובה'} ${rows ? 'למטה' : ''} עבור כל פריט :`
        } else {
          return 'יש לסמן את כל מה שמתאים:'
        }
      }
    },
    sh: {
      note: 'יש ללחוץ על מוצר כדי להגדיל אותו וכדי להוסיף אותו לעגלת הקניות הוירטואלית שלכם אם תרצו לקנות אותו בחנות',
      amazonNote:
        'יש ללחוץ על מוצר כדי להגדיל אותו וכדי להוסיף אותו לעגלת הקניות הוירטואלית שלכם אם תרצו לקנות אותו ברשת',
      fullCart: 'עגלת הקניות שלכם מלאה!',
      qty: 'כמות',
      each: 'יעדער',
      items: 'זאכן',
      addToCart: 'הוסיפו לעגלת הקניות',
      deleteFromCart: 'מחיקה',
      emptyCard: 'עגלת הקניות שלכם ריקה',
      total: 'עגלת הקניות',
      clearCart: 'רוקנו את עגלת הקניות',
      backToStore: 'בחזרה לחנות',
      na: 'אף אחד מהללו',
      scrollError: `נא לגלול שמאלה וימינה עד הסוף כדי להמשיך בסקר. `,
      next: 'הבא'
    },
    rb: {
      note: 'יש לבחור פריט אחד בלבד:'
    },
    vo: {
      note: 'יש לצפות בסרטון עד הסוף'
    },
    cb: {
      note: (min, max) => {
        if (1 === min && 5000 === max) {
          return 'יש לסמן את כל מה שמתאים:'
        } else if (min === max) {
          return ` יש לבחור לפחות ${min !== 1 ? 'כל' : 'בדיוק'} ${min} תו ${min !== 1 ? 'כלשהם' : 'בלבד'}:`
        } else if (min > 0 && max < 5000) {
          return ` יש לבחור לפחות ${min} פריט ${min !== 1 ? 'ים' : ''}  אך לא יותר מ- ${max} בכל שורה: `
        } else if (5000 === max && min > 0) {
          return ` יש לבחור לפחות ${min} פריט ${min !== 1 ? 'ים' : ''}:`
        } else if (0 === min && max < 5000) {
          return ` יש לבחור לא יותר מ ${max} פריט ${max !== 1 ? 'ים' : ''}:`
        } else {
          return 'יש לסמן את כל מה שמתאים:'
        }
      }
    },
    oe: {
      na: 'לא ישי',
      note: (min, max, optional) => {
        if (min === max) {
          return `יש להקליד ${1 !== min ? 'כל' : 'בדיוק'} ${min} תו${1 !== min ? 'וים' : ''}${
            optional ? ' (אופציונלי)' : ''
          }:`
        } else if (min > 0 && max < 5000) {
          return `יש להקליד לפחות ${min} תו ${1 !== min ? 'וים' : ''} אך לא יותר מ ${max}${
            optional ? ' (אופציונלי)' : ''
          }:`
        } else if (5000 === max && min > 0) {
          return `יש להקליד לפחות ${min} תו ${1 !== min ? 'וים' : ''}${optional ? ' (אופציונלי)' : ''}:`
        } else if (0 === min && max < 5000) {
          return `יש להקליד לא יותר מ ${max} תו ${1 !== min ? 'וים' : ''}${optional ? ' (אופציונלי)' : ''}:`
        } else {
          return ''
        }
      }
    },
    oex: {
      note: 'יש למלא את השדות הבאים:'
    },
    mx: {
      note: 'יש להזיז את המחוונים המודגשים כדי להמשיך',
      dragSlider: 'יש לגרור שמאלה או ימינה כדי לענות'
    },
    psc: {
      dragLeftRight: 'יש לגרור שמאלה או ימינה כדי לענות'
    },
    ps: {
      note: value => `יש לחלק  ${value} בין הפריטים שלמטה `,
      allDone: `סיימנו`,
      total: `Общо:`,
      dragSlider: 'יש לגרור שמאלה או ימינה כדי לענות'
    },
    cx: {
      note: 'פתחו את שדה הטקסט והחלו להקליד את התשובה שלכם כדי לגלול באופן אוטומטי, או בחרו באופן ידני'
    },
    ro: {
      note: 'יש לגרור למעלה או למטה כדי לסדר מחדש:'
    },
    md: {
      // eslint-disable-next-line no-useless-concat
      note1: 'יש ללחוץ/להקיש על הפריט הראשון שתרצו לבחור<br/>' + ' יש ללחוץ/להקיש שוב כדי לנקות את הבחירה.',
      // eslint-disable-next-line no-useless-concat
      note2: 'כעת יש ללחוץ/להקיש על הפריט האחרון שתרצו לבחור<br/>' + ' יש ללחוץ/להקיש שוב כדי לנקות את הבחירה.',
      note3: 'תודה! המשיכו לשאלה הבאה או לחצו/הקישו על כל פריט שלא נבחר כדי להתחיל מחדש.'
    },
    aro: {
      note: 'יש לבחור פריט אחד מכל צמד.'
    },
    wd: {
      note: 'יש לוודא שכל ערך עוקב גדול יותר מזה שלפניו.'
    },
    emd: {
      note: 'יש לצפות בסרטון עד הסוף',
      noAnswers: 'אין אפשרות לתשובה, יש ללחוץ ״הבא״ כדי להמשיך.',
      start: 'יש ללחוץ ולהחזיק כדי להתחיל',
      resume: 'יש ללחוץ ולהחזיק כדי להמשיך',
      continue: 'אתם מוכנים! יש ללחוץ ׳הבא׳ כדי להמשיך',
      continueMobile: 'אתם מוכנים! לחצו כאן כדי להמשיך',
      training: {
        session: 'אימון',
        note: 'יש לסיים את ההכשרה',
        moveLeft: 'יש לגרור את החוגה עד הסוף לצד שמאל',
        moveBottom: 'יש לגרור את החוגה עד הסוף לחלק התחתון',
        moveRight: 'עכשיו, בבקשה יש לגרור את החוגה עד הסוף לצדימין',
        moveTop: 'עכשיו, בבקשה יש לגרור את החוגה עד הסוף לחלק העליון',
        success: 'עבודה מעולה!'
      }
    },
    sft: {
      noAnswers: 'אין אפשרות לתשובה, יש ללחוץ ״הבא״ כדי להמשיך.',
      note: 'יש לענות כמה שיותר מהר תשובה שמרגישה נכונה באופן אינטואיטיבי',
      imageError: 'No image exposure time chosen',
      finish: 'סיימתם! יש ללחוץ ׳הבא׳ כדי להמשיך.',
      training: {
        start:
          '<p>בשאלה הזו יוצגו לכם מילים שונות במהירות ותידרשו להתרכז. תצטרכו להגיב במהירות כדי לענות </p>' +
          ' <p> מוכנים להתאמן?  </p>',
        step1: (touch, mouse, key) =>
          touch
            ? `הקישו "{buttonLeft}"`
            : (mouse ? `לחצו "{buttonLeft}"` : '') +
              (key && mouse ? ' / ' : '') +
              (key ? `הקישו על המקש  "{keyBtnLeft}"` : ''),
        step2: (touch, mouse, key) =>
          touch
            ? `הקישו "{buttonRight}"`
            : (mouse ? `לחצו "{buttonRight}"` : '') +
              (key && mouse ? ' / ' : '') +
              (key ? `הקישו על המקש  "{keyBtnRight}"` : ''),
        fail: () => 'לאט מדי',
        success: () => 'עבודה מעולה!',
        finish: () =>
          '<p><strong> מצוין!</strong></p><p>יש לוודא שדעתכם לא תהיה מוסחת ב-2-3 הדקות הבאות <br />' +
          '</p><p>לחצו ׳הבא׳ כדי להתחיל כשתהיו מוכנים</p>'
      },
      buttons: {
        start: 'התחלה',
        yesno: {
          left: 'כן',
          right: 'לא'
        },
        matches: {
          left: 'התאמה',
          right: 'לא התאמה'
        },
        fits: {
          left: 'מתאים',
          right: 'לא מתאים'
        },
        thumbs: {
          left: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsUp"></i>',
          right: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsDown"></i>'
        },
        noyes: {
          left: 'Да',
          right: 'Не'
        },
        matchesRev: {
          left: 'התאמה',
          right: 'לא התאמה'
        },
        fitsRev: {
          left: 'מתאים',
          right: 'לא מתאים'
        },
        thumbsRev: {
          left: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsUp"></i>',
          right: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsDown"></i>'
        }
      }
    }
  }
})
